// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"3626618f","220":"b7106c6e","416":"36f6cdd0","549":"639c7cc8","619":"3e15f35c","735":"85f03009","747":"255ff1f4","754":"ae5feaf1","765":"d7bd666d","793":"b1a92ed7","906":"56a692a9","929":"e2b181b6","969":"f83a0e3f"}[chunkId] + ".chunk.js";
};